import MainLayout from "../../layout";
import { useRole } from "../../context/role/RoleContext";

const Dashbaord = () => {
  const { state } = useRole();

  if (!state.role) return <div>Loading...</div>;

  return (
    <MainLayout>
      <h2>Role: {state.role.name}</h2>
      {state.role?.lead?.read && <p>✅ Can read leads</p>}
      {state.role?.lead?.write && <p>✅ Can write leads</p>}
      {state.role?.lead?.all_data && <p>✅ all data</p>}
      {state.role?.lead?.only_associated && <p>✅ only associated</p>}
    </MainLayout>
  );
};

export default Dashbaord;
